import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row gy-3 mb-3" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-3" }
const _hoisted_4 = { class: "col-lg-3" }
const _hoisted_5 = {
  key: 0,
  class: "col-12 col-lg-6 offset-lg-3 text-start mb-4"
}
const _hoisted_6 = { class: "row border p-2 d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mt-4 fw-normal" }, "Documentación del acompañante")
], -1)
const _hoisted_8 = { class: "col-12 col-lg-6 offset-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormNameCompanion = _resolveComponent("FormNameCompanion")!
  const _component_FormDni = _resolveComponent("FormDni")!
  const _component_FormAge = _resolveComponent("FormAge")!
  const _component_FormDigitalSignature = _resolveComponent("FormDigitalSignature")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormNameCompanion, {
        label: _ctx.labelName,
        placeholder: "formularios.nombreAcom.placeholder",
        fieldName: "nameCompanion",
        modelValue: _ctx.formulario.nombreApellido,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formulario.nombreApellido) = $event)),
        required: false
      }, null, 8, ["label", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormDni, {
        modelValue: _ctx.formulario.documento,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formulario.documento) = $event)),
        disabled: !_ctx.formulario.nombreApellido
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_FormAge, {
        modelValue: _ctx.formulario.edad,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formulario.edad) = $event)),
        disabled: !_ctx.formulario.nombreApellido
      }, null, 8, ["modelValue", "disabled"])
    ]),
    (Number(_ctx.formulario.edad) >= 18)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FormDigitalSignature, {
                label: "Firma del acompañante",
                modelValue: _ctx.formulario.imagenFirma,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formulario.imagenFirma) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}